import api from './api';

interface DeliveryZone {
  id?: number;
  commerce_id: number; // This remains number as it's the DB ID
  zone_name: string;
  zone_geometry: any;
  is_active?: boolean;
}

interface AddressVerificationResult {
  address: string;
  latitude: number;
  longitude: number;
  isDeliverable: boolean;
}

export const deliveryService = {
  getDeliveryZones: async (comercioKey: string): Promise<DeliveryZone[]> => {
    const response = await api.get(`/comercios/${comercioKey}/delivery-zones`);
    return response.data;
  },

  createDeliveryZone: async (comercioKey: string, zone: Omit<DeliveryZone, 'id' | 'commerce_id'>): Promise<DeliveryZone> => {
    const response = await api.post(`/comercios/${comercioKey}/delivery-zones`, zone);
    return response.data;
  },

  updateDeliveryZone: async (comercioKey: string, zoneId: number, zone: Partial<DeliveryZone>): Promise<DeliveryZone> => {
    const response = await api.put(`/comercios/${comercioKey}/delivery-zones/${zoneId}`, zone);
    return response.data;
  },

  deleteDeliveryZone: async (comercioKey: string, zoneId: number): Promise<void> => {
    await api.delete(`/comercios/${comercioKey}/delivery-zones/${zoneId}`);
  },

  createDefaultSpainDeliveryZone: async (comercioKey: string): Promise<DeliveryZone> => {
    const response = await api.post(`/comercios/${comercioKey}/delivery-zones/default-spain`);
    return response.data;
  },

  verifyDeliveryAddress: async (comercioKey: string, address: string): Promise<AddressVerificationResult> => {
    const response = await api.post(`/comercios/${comercioKey}/verify-delivery-address`, { address });
    return response.data;
  },

  // You might want to add methods to update commerce delivery settings (delivery_enabled, default_delivery_radius_km, etc.)
  // For example:
  // updateCommerceDeliverySettings: async (comercioKey: string, settings: { delivery_enabled?: boolean, default_delivery_radius_km?: number }) => {
  //   const response = await api.put(`/comercios/${comercioKey}/settings`, settings);
  //   return response.data;
  // }
};